import {REGISTER_REQUEST, REGISTER_SUCCESS, REGISTER_FAILURE} from '../actions';

export const REGISTER_INITIAL_STATE = {
    isFetching: false,
    data: {}
};

const registerReducers = {
    [REGISTER_REQUEST]: (state, {data}) => {
        return Object.assign({}, state, {
            isFetching: true,
            data,
            error: null
        });
    },
    [REGISTER_SUCCESS]: (state, {res}) => {
        return Object.assign({}, state, {
            isFetching: false,
            res,
            error: null
        });
    },
    [REGISTER_FAILURE]: (state, {error}) => {
        return Object.assign({}, state, {
            isFetching: false,
            error
        });
    }
};

export default function register(state = REGISTER_INITIAL_STATE, action) {
    let reducer = registerReducers[action.type] || (state => state);
    return reducer(state, action);
}


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/app-register.js